import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SITE_ORIGIN } from '../config/site';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'AKAS',
  url: SITE_ORIGIN,
  logo: `${SITE_ORIGIN}/images/akas-logo.png`,
  email: 'info@akas.co',
  telephone: '+85510440600',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Phnom Penh',
    addressCountry: 'KH',
  },
  sameAs: [
    'https://www.linkedin.com/company/akas-co/',
    'https://facebook.com/www.akas.co',
  ],
};

const OrganizationJsonLd: React.FC = () => (
  <Helmet>
    <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
  </Helmet>
);

export default OrganizationJsonLd;
